require('../../modules/es.object.to-string');
require('../../modules/es.promise');
require('../../modules/es.string.iterator');
require('../../modules/esnext.async-iterator.constructor');
require('../../modules/esnext.async-iterator.from');
require('../../modules/web.dom-collections.iterator');

var path = require('../../internals/path');

module.exports = path.AsyncIterator.from;
